export const formatDisplayNumber = (x, delimiter = ',', defaultValue = '0') => {
  if (x === '--' || !x) {
    return defaultValue;
  }
  return new Intl.NumberFormat('ja-JP').format(Number(x));
};

export const formatDisplayNumberWithSuffix = (
  x,
  delimiter = ',',
  defaultValue = '--',
  suffixOptions = null
) => {
  if (x === '--' || !x) {
    return defaultValue;
  }

  let newValue = x;
  let suffix = suffixOptions?.default || '';
  const value = x < 0 ? x * -1 : x;
  if (value > 1000000000) {
    newValue = Math.round(Number(x) / 1000000000);
    suffix = suffixOptions?.b || 'B';
  } else if (value > 1000000) {
    newValue = Math.round(Number(x) / 1000000);
    suffix = suffixOptions?.m || 'M';
  } else if (value > 1000) {
    newValue = Math.round(Number(x) / 1000);
    suffix = suffixOptions?.k || 'K';
  }

  return `${new Intl.NumberFormat('ja-JP').format(Number(newValue))}${suffix}`;
};

export const formatDisplayNumberWithSuffix2 = (
  x,
  fractionDigit = 0,
  defaultValue = '--',
  suffixOptions = null
) => {
  if (x === '--' || !x) {
    return defaultValue;
  }

  let newValue = x;
  let suffix = suffixOptions?.default || '';
  const value = x < 0 ? x * -1 : x;
  if (value > 1000000000) {
    newValue = parseFloat((Number(x) / 1000000000).toFixed(fractionDigit));
    suffix = suffixOptions?.b || 'B';
  } else if (value > 1000000) {
    newValue = parseFloat((Number(x) / 1000000).toFixed(fractionDigit));
    suffix = suffixOptions?.m || 'M';
  } else if (value > 1000) {
    newValue = parseFloat((Number(x) / 1000).toFixed(fractionDigit));
    suffix = suffixOptions?.k || 'K';
  }
  return `${new Intl.NumberFormat('ja-JP').format(Number(newValue))}${suffix}`;
};

export const formatTradingValue = (value, fractionDigit = 2, limit = 10) => {
  const newValue = parseFloat(value.toFixed(fractionDigit));
  if (Math.abs(newValue) > 0 || fractionDigit >= limit) {
    return newValue;
  }

  return formatTradingValue(value, fractionDigit + 1);
};
